import request from '@/request'
import { AUTH } from '@/data/api'
import ability from '@/store/ability'

export default {
  namespaced: true,
  state: {
    token: false,
    user: false,
    role: false,
    requests: false,
    manager: false,
    managed: false,
    rules: []
  },
  getters: {
    isAuth: state => !!state.token,
    user: state => state.user,
    role: state => state.role,
    requests: state => state.requests,
    manager: state => state.manager,
    managed: state => state.managed
  },
  mutations: {
    setToken (state, token) {
      localStorage.setItem('authToken', token)
      state.token = token
      request.defaults.headers.common['Authorization'] = `Bearer ${token}`
    },
    setUser (state, user) {
      state.user = user
    },
    setRole (state, role) {
      state.role = role
    },
    setRequests (state, requests) {
      if (typeof requests !== 'undefined') {
        state.requests = requests.length > 0 ? requests : false
      }
    },
    setManager (state, managedBy) {
      if (typeof managedBy !== 'undefined' && managedBy !== null) {
        state.manager = managedBy
      }
    },
    setManaged (state, fusebox) {
      if (typeof fusebox !== 'undefined' && fusebox !== null) {
        state.managed = fusebox
      }
    },
    updatePermissions (state, permissions) {
      const caslPerms = []
      permissions.map(value => {
        caslPerms.push({
          subject: value.name,
          actions: value.permissions
        })
      })
      state.rules = caslPerms
      ability.update(caslPerms)
    },
    clearToken (state) {
      localStorage.removeItem('authToken')
      state.token = false
      state.user = false
      state.role = false
      state.requests = false
      state.rules = []
      delete request.defaults.headers.common['Authorization']
      ability.update([])
    },
    changeCompany (state, { form, image }) {
      state.user.company = { ...form }
      state.user.company.logo = image
    }
  },
  actions: {
    async init ({ commit, dispatch }) {
      const token = localStorage.getItem('authToken') || false
      if (token !== false) {
        commit('setToken', token)
        await dispatch('user')
      }
    },
    async login ({ commit, dispatch }, params) {
      try {
        const { data } = await request.post(AUTH.LOGIN, params)
        commit('setToken', data.access_token)
        commit('setUser', data.user)
        commit('setRequests', data.user.access_requests)
        commit('setManager', data.user.managed_by)
        commit('setManaged', data.user.managed_fusebox)
        commit('setRole', data.user.role)
        commit('updatePermissions', data.user.permissions)
      } catch (e) {
        throw e
      }
    },
    async loginas ({ commit, dispatch }, params) {
      try {
        const { data } = await request.post(AUTH.LOGINAS, params)
        commit('setToken', data.access_token)
        commit('setUser', data.user)
        commit('setRequests', data.user.access_requests)
        commit('setManager', data.user.managed_by)
        commit('setManaged', data.user.managed_fusebox)
        commit('setRole', data.user.role)
        commit('updatePermissions', data.user.permissions)
      } catch (e) {
        throw e
      }
    },
    async user ({ commit }) {
      try {
        const { data } = await request.get(AUTH.USER)
        commit('setUser', data)
        commit('setRole', data.role)
        commit('setRequests', data.access_requests)
        commit('setManager', data.managed_by)
        commit('setManaged', data.managed_fusebox)
        commit('updatePermissions', data.permissions)
      } catch (e) {
        commit('setUser', false)
      }
    },
    async userUpdate ({ commit }, formData) {
      try {
        const { data } = await request.post(AUTH.USER, formData)
        commit('setUser', data.data)
      } catch (e) {
        throw e
      }
    },
    async logout ({ commit, dispatch }) {
      try {
        await request.post(AUTH.LOGOUT)
        commit('clearToken')
        commit('resetState', null, { root: true })
      } catch (e) {
        commit('clearToken')
        commit('resetState', null, { root: true })
      }
    },
    async register (context, params) {
      try {
        const { data } = await request.post(AUTH.REGISTER, params)
        return data
      } catch (e) {
        throw e
      }
    },
    async activate ({ commit }, token) {
      try {
        const { data } = await request.get(`${AUTH.ACTIVATION}/${token}`)
        return data
      } catch (e) {
        throw e
      }
    },
    async resetLinkGenerate (context, params) {
      try {
        const { data } = await request.post(AUTH.RESET, params)
        return data
      } catch (e) {
        throw e
      }
    },
    async resetTokenVerification (context, token) {
      try {
        const { data } = await request.get(`${AUTH.VERIFICATION}/${token}`)
        return data
      } catch (e) {
        throw e
      }
    },
    async createTokenVerification (context, token) {
      try {
        const { data } = await request.get(`${AUTH.CREATE_PASSWORD.VERIFICATION}/${token}`)
        return data
      } catch (e) {
        throw e
      }
    },
    async createNewPassword (context, params) {
      try {
        const { data } = await request.post(AUTH.NEWPASSWORD, params)
        return data
      } catch (e) {
        throw e
      }
    },
    async createNewPasswordForDesigner (context, params) {
      try {
        const { data } = await request.post(AUTH.CREATE_PASSWORD.CREATE, params)
        return data
      } catch (e) {
        throw e
      }
    },
    async personalRegister (context, params) {
      try {
        const { data } = await request.post(AUTH.PERSONAL_REGISTER, params)
        return data
      } catch (e) {
        throw e
      }
    }
  }
}
